import { render, staticRenderFns } from "./farmSelection.vue?vue&type=template&id=bf597e2c&scoped=true&"
import script from "./farmSelection.vue?vue&type=script&lang=js&"
export * from "./farmSelection.vue?vue&type=script&lang=js&"
import style0 from "./farmSelection.vue?vue&type=style&index=0&id=bf597e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf597e2c",
  null
  
)

export default component.exports